var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}
/*eslint radix: ["error", "as-needed"]*/


import Filters from './Filters';
import { action, observable, computed } from 'mobx';
import { createTransformer } from 'mobx-utils';
import { isFunction } from 'lodash';
var FilterStore = (_class = function () {
  function FilterStore() {
    var _this = this;

    _classCallCheck(this, FilterStore);

    _initDefineProp(this, 'fullTextSearch', _descriptor, this);

    _initDefineProp(this, 'underMonitoring', _descriptor2, this);

    _initDefineProp(this, 'changes', _descriptor3, this);

    _initDefineProp(this, 'filterPage', _descriptor4, this);

    this.globalFilterFunctionFromPage = createTransformer(function (page) {
      var globalFilterFunctionFromPage = _this._globalFilterFunction.get(page);

      return globalFilterFunctionFromPage;
    }); // this.filtersHandler = new Filters();

    this.filtersHandler = observable.map([['base', new Filters()]]);
    this._globalFilterFunction = observable.map([['base', undefined]]);
    this._appliedFilters = observable.map([['base', undefined]]);
    this._rawFilters = observable.map([['base', {}]]);
    this._filtersParameters = observable.map([['base', {}]]);
    this._appliedFiltersParameters = observable.map([['base', {}]]);
  } // @observable appliedFilters;


  FilterStore.prototype.setupPage = function setupPage(page) {
    if (!this.filtersHandler.has(page)) {
      this.filtersHandler.set(page, new Filters());

      this._globalFilterFunction.set(page, undefined);

      this._appliedFilters.set(page, undefined);

      this._rawFilters.set(page, {});

      this._filtersParameters.set(page, {});

      this._appliedFiltersParameters.set(page, {});
    }

    this.switchToPage(page);
  };

  FilterStore.prototype.switchToPage = function switchToPage(page) {
    this.filterPage = page;
    return this;
  };

  FilterStore.prototype.addToMonitoring = function addToMonitoring(name) {
    if (this.underMonitoring.findIndex(function (filterName) {
      return filterName === name;
    }) === -1) {
      this.underMonitoring.push(name);
    }
  };

  FilterStore.prototype.removeFromMonitoring = function removeFromMonitoring(name) {
    this.underMonitoring.pop(name);
  };

  FilterStore.prototype.add = function add(name, fn) {
    var _extends2;

    var toggle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var parameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    var filterNamespace = name.split('.');

    switch (filterNamespace.length) {
      case 1:
        //and
        this.filtersHandler.get(this.filterPage).andFilter(filterNamespace[0], fn, toggle);
        this.changes = true;
        break;

      case 2:
        //or
        this.filtersHandler.get(this.filterPage).orFilter(filterNamespace[0], filterNamespace[1], fn, toggle);
        this.changes = true;
        break;

      default:
        throw new Error('filter name should be of the form <name> or <group>.<name>');
    } // this.rawFilters = this.filtersHandler.get(this.filterPage).getFilters();


    this._rawFilters.set(this.filterPage, this.filtersHandler.get(this.filterPage).getFilters());

    this._filtersParameters.set(this.filterPage, _extends({}, this._filtersParameters.get(this.filterPage), (_extends2 = {}, _extends2[name] = parameters, _extends2)));
  }; //the actual selected filter


  FilterStore.prototype.remove = function remove(name) {
    var _extends3;

    var filterNamespace = name.split('.');

    switch (filterNamespace.length) {
      case 1:
        //and
        this.filtersHandler.get(this.filterPage).removeAndFilter(name);
        this.changes = true;
        break;

      case 2:
        //or
        this.filtersHandler.get(this.filterPage).removeOrFilter(filterNamespace[0], filterNamespace[1]);
        this.changes = true;
        break;

      default:
        throw new Error('filter name should be of the form <name> or <group>.<name>');
    } // this.rawFilters = this.filtersHandler.get(this.filterPage).getFilters();


    this._rawFilters.set(this.filterPage, this.filtersHandler.get(this.filterPage).getFilters());

    this._filtersParameters.set(this.filterPage, _extends({}, this._filtersParameters.get(this.filterPage), (_extends3 = {}, _extends3[name] = {}, _extends3)));
  };
  /**
   * set the actual filter
   */


  FilterStore.prototype.apply = function apply() {
    this._globalFilterFunction.set(this.filterPage, this.filtersHandler.get(this.filterPage).filterFn());

    this._appliedFilters.set(this.filterPage, this.filtersHandler.get(this.filterPage).getFilters());

    this._appliedFiltersParameters.set(this.filterPage, this._filtersParameters.get(this.filterPage));

    this.changes = false;
  };

  FilterStore.prototype.contains = function contains(filterName) {
    if (filterName instanceof RegExp) {
      return Object.keys(this.rawFilters || {}).findIndex(function (filterKey) {
        return filterName.test(filterKey);
      }) > -1;
    } else {
      return Object.keys(this.rawFilters || {}).findIndex(function (filterKey) {
        return filterKey === filterName;
      }) > -1;
    }
  };

  FilterStore.prototype.appliedFiltersLengthFor = function appliedFiltersLengthFor(prefix) {
    return Object.keys(this.appliedFilters || {}).filter(function (appliedFilterKey) {
      return appliedFilterKey.startsWith(prefix);
    }).length;
  };

  FilterStore.prototype.appliedFiltersContains = function appliedFiltersContains(filterName) {
    if (filterName instanceof RegExp) {
      return Object.keys(this.appliedFilters || {}).findIndex(function (filterKey) {
        return filterName.test(filterKey);
      }) > -1;
    } else {
      return Object.keys(this.appliedFilters || {}).findIndex(function (filterKey) {
        return filterKey === filterName;
      }) > -1;
    }
  };

  FilterStore.prototype.reset = function reset() {
    var apply = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.filtersHandler.get(this.filterPage).reset(); // this.rawFilters = {};

    this._rawFilters.set(this.filterPage, {});

    this._filtersParameters.set(this.filterPage, {});

    if (apply) {
      this.apply();
    }
  };

  FilterStore.prototype.resetFor = function resetFor(prefix) {
    var _this2 = this;

    var apply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    Object.keys(this.rawFilters || {}).filter(function (filterKey) {
      return filterKey.startsWith(prefix);
    }).forEach(function (filterKey) {
      _this2.remove(filterKey);
    });

    if (apply) {
      this.apply();
    }
  };

  FilterStore.prototype.addFiltersUnderMonitor = function addFiltersUnderMonitor(appliedFilterName, appliedFilterValue, filtersHandler) {
    if (isFunction(appliedFilterValue)) {
      filtersHandler.andFilter(appliedFilterName, appliedFilterValue, true);
    } else {
      Object.keys(appliedFilterValue || []).forEach(function (innerAppliedFilter) {
        filtersHandler.orFilter(appliedFilterName, innerAppliedFilter, appliedFilterValue[innerAppliedFilter], true);
      });
    }
  };

  _createClass(FilterStore, [{
    key: 'filters',
    get: function get() {
      var _this3 = this;

      var computedFilters = {};
      var firstLevelKeys = Object.keys(this.rawFilters);
      firstLevelKeys.forEach(function (key) {
        if (isFunction(_this3.rawFilters[key])) {
          computedFilters[key] = true;
        } else {
          var secondLevelKey = Object.keys(_this3.rawFilters[key]);
          secondLevelKey.forEach(function (key2) {
            if (isFunction(_this3.rawFilters[key][key2])) {
              computedFilters[key + '.' + key2] = true;
            }
          });
        }
      });
      return computedFilters;
    }
  }, {
    key: 'hasAppliedFilters',
    get: function get() {
      return Object.keys(this.appliedFilters || {}).length > 0;
    }
  }, {
    key: 'appliedFiltersLength',
    get: function get() {
      return Object.keys(this.appliedFilters || {}).length;
    }
  }, {
    key: 'predictionFns',
    get: function get() {
      var _this4 = this;

      var predFns = {};
      this.underMonitoring.forEach(function (filterToBeMonitored) {
        var filterNamespace = filterToBeMonitored.split('.');
        var filtersHandler = new Filters();
        Object.keys(_this4.appliedFilters || []).forEach(function (appliedFilterName) {
          var appliedFilterValue = _this4.appliedFilters[appliedFilterName];

          if (appliedFilterName != filterNamespace[0]) {
            _this4.addFiltersUnderMonitor(appliedFilterName, appliedFilterValue, filtersHandler);
          }
        });
        predFns[filterToBeMonitored] = filtersHandler.filterFn();
      });
      return predFns;
    }
  }, {
    key: 'globalFilterFunction',
    get: function get() {
      var globalFilterFunction = this._globalFilterFunction.get(this.filterPage);

      if (globalFilterFunction === undefined) {
        globalFilterFunction = function globalFilterFunction() {
          return true;
        };
      }

      return globalFilterFunction;
    }
  }, {
    key: 'appliedFilters',
    get: function get() {
      var appliedFilters = this._appliedFilters.get(this.filterPage);

      return appliedFilters;
    }
  }, {
    key: 'rawFilters',
    get: function get() {
      var rawFilters = this._rawFilters.get(this.filterPage);

      return rawFilters;
    }
  }, {
    key: 'appliedFiltersParameters',
    get: function get() {
      return this._appliedFiltersParameters.get(this.filterPage);
    }
  }]);

  return FilterStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'fullTextSearch', [observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'underMonitoring', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'changes', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'filterPage', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return 'base';
  }
}), _applyDecoratedDescriptor(_class.prototype, 'add', [action], Object.getOwnPropertyDescriptor(_class.prototype, 'add'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'filters', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'filters'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'remove', [action], Object.getOwnPropertyDescriptor(_class.prototype, 'remove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'apply', [action], Object.getOwnPropertyDescriptor(_class.prototype, 'apply'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasAppliedFilters', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'hasAppliedFilters'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'appliedFiltersLength', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'appliedFiltersLength'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reset', [action], Object.getOwnPropertyDescriptor(_class.prototype, 'reset'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetFor', [action], Object.getOwnPropertyDescriptor(_class.prototype, 'resetFor'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'predictionFns', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'predictionFns'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'globalFilterFunction', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'globalFilterFunction'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'appliedFilters', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'appliedFilters'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'rawFilters', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'rawFilters'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'appliedFiltersParameters', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'appliedFiltersParameters'), _class.prototype)), _class);
export default new FilterStore();